if (!customElements.get("products-toolbar")) {
  class t extends HTMLElement {
    constructor() {
      super(), window.initLazyScript(this, this.init.bind(this))
    }
    init() {
      if (this.filtersComponent = document.querySelector("facet-filters"), this.filtersColumn =
        document.querySelector(".main-products-grid__filters"), this.layoutSwitcher = this
        .querySelector(".products-toolbar__layout"), this.compareToggle = document.getElementById(
          "compare-switch"), this.sortBy = this.querySelector(".products-toolbar__sort"), this
        .productsGrid = document.querySelector(".main-products-grid"), this.filtersColumn && (this
          .filterToggle = this.querySelector(".js-toggle-filters"), this.filterToggle
          .addEventListener("click", this.toggleFilters.bind(this))), this.layoutSwitcher) {
        this.layoutSwitcher.addEventListener("change", this.handleLayoutChange.bind(this));
        let e = theme.storageUtil.get("products-layout");
        if (e && "list" === e) {
          let s = document.getElementById(`${e}-layout-opt`);
          s && s.click()
        }
      }
      if (this.compareToggle) {
        this.compareToggle.addEventListener("change", this.toggleCompare.bind(this));
        let i = theme.storageUtil.get("compare-toggle", !0);
        null !== i ? this.toggleCompare(null, i, !0) : this.toggleCompare(null, this.compareToggle
          .checked, !1), setTimeout(() => {
          this.classList.add("transition-ready"), this.productsGrid.classList.add(
            "transition-ready")
        }, 500)
      } else "none" === theme.settings.compareToggle && this.toggleCompare(null, !0, !1);
      !this.filtersComponent && this.sortBy && this.sortBy.addEventListener("change", t
        .handleSortByChange)
    }
    toggleCompare(t, e = null, s = !0) {
      let i = t ? t.target.checked : e;
      this.productsGrid.dataset.compare = i;
      let l = document.getElementById("compare-drawer-open");
      if (l.classList.toggle("is-out", !i), !t && this.compareToggle && (this.compareToggle
          .checked = i), s && !Shopify.designMode && theme.storageUtil.set("compare-toggle", i),
        i) {
        let r = document.getElementById("compare-resources");
        if (r) {
          let o = JSON.parse(r.textContent);
          o.forEach(t => {
            if ("js" === t.type) {
              let e = document.createElement("script");
              e.src = t.path, document.head.appendChild(e)
            } else if ("css" === t.type) {
              let s = document.createElement("link");
              s.href = t.path, s.type = "text/css", s.rel = "stylesheet", document.head
                .appendChild(s)
            }
          }), r.remove()
        }
      }
    }
    toggleFilters() {
      if (this.filterToggle.classList.toggle("is-active"), this.filtersOpen = this.filterToggle
        .classList.contains("is-active"), this.filterToggle.setAttribute("aria-expanded", this
          .filtersOpen), theme.mediaMatches.lg) {
        this.filtersColumn.classList.toggle("lg:js-hidden", !this.filtersOpen);
        let t = document.querySelector(".main-products-grid__results > .grid");
        t.className = this.filtersOpen ? t.dataset.filtersOpenClasses : t.dataset
          .filtersClosedClasses
      } else this.filtersComponent.open()
    }
    handleLayoutChange(t) {
      this.productsGrid.dataset.layout = t.target.value, theme.storageUtil.set("products-layout",
        t.target.value)
    }
    static handleSortByChange(t) {
      let e = new URL(window.location.href);
      e.searchParams.set("sort_by", t.detail.selectedValue), e.hash = "products-toolbar", window
        .location.href = e.toString()
    }
  }
  customElements.define("products-toolbar", t)
}
